export const useAppTrackingTransparency = () => {
  return false; // this feature is only for iOS.
};
